import type { DailyMetric, DailyMetrics, DailyMetricsEnvelope } from './metrics.endpoints';

type RawDailyMetric = {
  time?: string;
  date?: string;
  records: number;
  size: number;
  errors: number;
};

type DailyMetricsApiResponse = {
  status: string;
  output: RawDailyMetric[];
};

function normalizeMetricItem({ time, date, ...rest }: RawDailyMetric): DailyMetric {
  return { ...rest, time: time ?? date ?? '' };
}

export function parseDailyMetricsResponse(raw: unknown): DailyMetrics {
  if (raw && typeof raw === 'object') {
    if ('metrics' in raw && Array.isArray((raw as DailyMetricsEnvelope).metrics))
      return (raw as DailyMetricsEnvelope).metrics.map(normalizeMetricItem);

    if ('output' in raw && Array.isArray((raw as DailyMetricsApiResponse).output))
      return (raw as DailyMetricsApiResponse).output.map(normalizeMetricItem);
  }
  return [];
}
